export class VHChromeFix{
    constructor(selectors) {
        this.selectors          = this.is_array(selectors) ? selectors : [selectors];
        this.user_agent         = navigator.userAgent.toLowerCase();
        const is_android_chrome = /chrome/.test(this.user_agent) && /android/.test(this.user_agent);
        const is_ios_chrome     = /crios/.test(this.user_agent);
        const is_safari         = /safari/.test(this.user_agent);

        if(is_android_chrome || is_ios_chrome || is_safari){
            // If we detected Chrome on Android or iOS
            // Cache elements and trigger fix on init
            this.get_elements(selectors);
            this.fix_all();

            // Cache window dimensions
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;

            this.init_events();
        }
    }

    init_events()
    {
        window.addEventListener('resize', () => {
            // Both width and height changed (orientation change)
            // This is a hack, as Android when keyboard pops up
            // Triggers orientation change
            if (this.windowWidth !== window.innerWidth && this.windowHeight !== window.innerHeight) {
                this.windowWidth = window.innerWidth;
                this.windowHeight = window.innerHeight;
                this.fix_all();
            }
        });
    }

    get_elements()
    {
        this.elements = [];

        for(let i = 0; i < this.selectors.length; i++) {
            // Get all elements for selector
            const selector = this.selectors[i].selector;
            const elements = document.querySelectorAll(selector);

            // Go through all elements for one selector to filter them
            for(let j = 0; j < elements.length; j++) {
                this.elements.push({
                    domElement: elements[j],
                    vh: this.selectors[i].vh
                });
            }
        }
    }

    is_array(array)
    {
        return Object.prototype.toString.call(array) === '[object Array]';
    }

    fix_all() {
        const windowHeight = window.innerHeight; // lees 1x
        requestAnimationFrame(() => {
            for(let i = 0; i < this.elements.length; i++) {
                const element = this.elements[i];
                element.domElement.style.height = (windowHeight * element.vh / 100) + 'px';
            }
        });
    }


    // fix_all()
    // {
    //     for(let i = 0; i < this.elements.length; i++) {
    //         const element = this.elements[i];
    //         element.domElement.style.height = (window.innerHeight * element.vh / 100) + 'px';
    //     }
    // }
}
